module.exports = __webpack_public_path__ + "img/file-pdf.df9885f6.svg";